import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import hexRgb from 'hex-rgb';
import camo from '../../images/camo.gif';
import camoSmall from '../../images/camo_small.gif';
import heathered from '../../images/heathered.gif';
import heatheredSmall from '../../images/heathered_small.gif';
import tiedye from '../../images/tiedye.gif';
import tiedyeSmall from '../../images/tiedye_small.gif';
var hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
export var getBackground = function (size, color, trimRgb, special) {
    switch (special) {
        case 'camo':
            return size === 'large'
                ? { backgroundImage: "url(".concat(camo, ")") }
                : { backgroundImage: "url(".concat(camoSmall, ")") };
        case 'heathered':
            return size === 'large'
                ? { backgroundImage: "url(".concat(heathered, ")") }
                : { backgroundImage: "url(".concat(heatheredSmall, ")") };
        case 'tiedye':
            return size === 'large'
                ? { backgroundImage: "url(".concat(tiedye, ")") }
                : { backgroundImage: "url(".concat(tiedyeSmall, ")") };
        default:
            return getBackgroundColor(color, trimRgb);
    }
};
function getBackgroundColor(color, trimRgb) {
    if (color && color.match(hexRegex)) {
        if (trimRgb && trimRgb.match(hexRegex)) {
            return {
                background: "linear-gradient(90deg, ".concat(color, " 66%, ").concat(trimRgb, " 66%)"),
            };
        }
        return { backgroundColor: color };
    }
    return {};
}
export var getRgb = function (color) {
    if (!color ||
        typeof color !== 'string' ||
        (typeof color.match === 'function' && !color.match(hexRegex))) {
        return undefined;
    }
    var rgb = hexRgb(color);
    return rgb
        ? {
            r: rgb.red,
            g: rgb.green,
            b: rgb.blue,
        }
        : undefined;
};
export var isLuminanceBelow = function (rgb, threshold) {
    if (rgb === void 0) { rgb = { r: 255, g: 255, b: 255 }; }
    if (threshold === void 0) { threshold = 179; }
    return 0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b < threshold;
};
export var getContrastColor = function (hexFallback, rgb) {
    return isLuminanceBelow(rgb, 179)
        ? designTokens.color.shade.white.value
        : hexFallback;
};
export var checkmarkContrast = function (rgb, special) {
    if (special) {
        return designTokens.color.shade.white.value;
    }
    else {
        return getContrastColor(designTokens.color.shade.black.value, rgb);
    }
};
export var subtletyContrast = function (rgb, special) {
    if (special) {
        return designTokens.color.shade.white.value;
    }
    else {
        return getContrastColor(designTokens.color.gray.slateDark.value, rgb);
    }
};
//# sourceMappingURL=colors.js.map